"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isEventDetailsStencil = exports.eventDetailsStencilDefinition = void 0;
const constraint_model_1 = require("../models/constraints/constraint.model");
const properties_1 = require("../properties");
const wrcErcContentAreas = [
    {
        name: 'main',
        items: [
            'title',
            'teaser',
            'story-content',
        ],
    },
    {
        name: 'info',
        subAreas: [
            {
                name: 'General',
                items: [
                    'seo-title',
                    'social-title',
                    'uri-title',
                    'featured-media',
                    'featured-video',
                    'geolocation',
                ],
            },
            {
                name: 'Partners',
                items: ['partner-profiles'],
            },
            {
                name: 'Settings',
                items: [
                    'content-classification-terms',
                    'standalone',
                    'no-monetization',
                ],
            },
            {
                name: 'Custom Properties',
                items: ['properties-container'],
            },
        ],
    },
    {
        name: 'tagging',
        items: [
            'disciplines',
            'content-categories',
            'tag-events',
            'tag-event-series',
            'tag-rally-drivers',
            'tag-rally-teams',
            'related-content',
        ],
    },
];
const wrcErcProperties = {
    [properties_1.serviceEmbedPropertyDefinition.name]: {
        ...properties_1.serviceEmbedPropertyDefinition,
        constraints: [
            {
                name: 'providers',
                argument: constraint_model_1.wrcErcServiceEmbedProviders,
            },
        ],
    },
};
exports.eventDetailsStencilDefinition = {
    view: {
        label: 'Subpage',
        category: 'event-details',
        group: 'Misc.',
        titleItems: ['title'],
        imageItems: ['featured-media'],
        contentAreas: [
            {
                name: 'main',
                items: [
                    'title',
                    'teaser',
                    'story-content',
                ],
            },
            {
                name: 'info',
                subAreas: [
                    {
                        name: 'General',
                        items: [
                            'seo-title',
                            'social-title',
                            'uri-title',
                            'featured-media',
                            'featured-video',
                            'geolocation',
                        ],
                    },
                    {
                        name: 'Partners',
                        items: ['partner-profiles'],
                    },
                    {
                        name: 'Settings',
                        items: [
                            'content-classification-terms',
                            'standalone',
                            'no-monetization',
                        ],
                    },
                    {
                        name: 'Custom Properties',
                        items: ['properties-container'],
                    },
                ],
            },
            {
                name: 'tagging',
                items: [
                    'disciplines',
                    'content-categories',
                    'tag-events',
                    'tag-event-series',
                    'tag-persons',
                    'tag-teams',
                    'related-content',
                ],
            },
        ],
    },
    content: {
        [properties_1.contentCategoriesPropertyDefinition.name]: properties_1.contentCategoriesPropertyDefinition,
        [properties_1.contentClassificationTermsPropertyDefinition.name]: properties_1.contentClassificationTermsPropertyDefinition,
        [properties_1.disciplinesPropertyDefinition.name]: properties_1.disciplinesPropertyDefinition,
        [properties_1.featuredMediaPropertyDefinition.name]: properties_1.featuredMediaPropertyDefinition,
        [properties_1.featuredVideoPropertyDefinition.name]: properties_1.featuredVideoPropertyDefinition,
        [properties_1.geolocationPropertyDefinition.name]: properties_1.geolocationPropertyDefinition,
        [properties_1.noMonetizationPropertyDefinition.name]: properties_1.noMonetizationPropertyDefinition,
        [properties_1.partnerProfilesPropertyDefinition.name]: properties_1.partnerProfilesPropertyDefinition,
        [properties_1.propertiesContainerPropertyDefinition.name]: properties_1.propertiesContainerPropertyDefinition,
        [properties_1.relatedContentPropertyDefinition.name]: properties_1.relatedContentPropertyDefinition,
        [properties_1.seoTitlePropertyDefinition.name]: properties_1.seoTitlePropertyDefinition,
        [properties_1.socialTitlePropertyDefinition.name]: properties_1.socialTitlePropertyDefinition,
        [properties_1.standalonePropertyDefinition.name]: properties_1.standalonePropertyDefinition,
        [properties_1.storyContentPropertyDefinition.name]: {
            ...properties_1.storyContentPropertyDefinition,
            constraints: [
                {
                    name: 'properties',
                    argument: [
                        'text',
                        'headline',
                        'quote',
                        'list',
                        'numbered-list',
                        'table',
                        'service-embed',
                        'image',
                        'image-gallery',
                        'video',
                        'audio',
                        'tip',
                        'fact',
                        'couple',
                        'interview',
                        'accordion',
                        'embedded-content',
                        'results-and-standings',
                        'legal-disclaimer',
                        'info-block-group',
                    ],
                },
            ],
        },
        [properties_1.tagEventSeriesPropertyDefinition.name]: properties_1.tagEventSeriesPropertyDefinition,
        [properties_1.tagEventsPropertyDefinition.name]: properties_1.tagEventsPropertyDefinition,
        [properties_1.tagPersonsPropertyDefinition.name]: properties_1.tagPersonsPropertyDefinition,
        [properties_1.tagRallyDriversPropertyDefinition.name]: properties_1.tagRallyDriversPropertyDefinition,
        [properties_1.tagRallyTeamsPropertyDefinition.name]: properties_1.tagRallyTeamsPropertyDefinition,
        [properties_1.tagTeamsPropertyDefinition.name]: properties_1.tagTeamsPropertyDefinition,
        [properties_1.teaserPropertyDefinition.name]: properties_1.teaserPropertyDefinition,
        [properties_1.titlePropertyDefinition.name]: properties_1.titlePropertyDefinition,
        [properties_1.uriTitlePropertyDefinition.name]: properties_1.uriTitlePropertyDefinition,
    },
    localizations: [],
    roles: [],
    spaces: [
        'alinghi',
        'batalla',
        'brand-building-events',
        'erc',
        'global',
        'illume',
        'media-partnerships',
        'organics',
        'organics-mixed-consumption',
        'pro-cycling',
        'racing-bulls',
        'rb-juniorteam',
        'rb-rookies',
        'rbtv',
        'rbtv_temporary',
        'redbull_com',
        'redbull-advancedtechnologies',
        'redbull-f1academy',
        'redbull-powertrains',
        'redbull-racing',
        'redbull-simracing',
        'redbulletin',
        'redbullmusic',
        'wingfinder',
        'wrc',
        'xalps',
    ],
    name: 'event-details',
    overwrites: [
        {
            condition: 'space',
            argument: 'erc',
            contentAreas: wrcErcContentAreas,
            properties: wrcErcProperties,
        },
        {
            condition: 'space',
            argument: 'wrc',
            contentAreas: wrcErcContentAreas,
            properties: wrcErcProperties,
        },
    ],
};
const isEventDetailsStencil = (stencil) => {
    return stencil.name === exports.eventDetailsStencilDefinition.name;
};
exports.isEventDetailsStencil = isEventDetailsStencil;
//# sourceMappingURL=data:application/json;base64,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